<template>
  <span class="terrain-badge" :class="`terrain-badge--${type}`">{{ message }}</span>
</template>

<script>
// TerrainBadge — mismo estilo de "tag" ya usado en TerrainCampaigns.vue
// (.terrain-campaigns__tag--published/closed/deleted/draft), extraído para
// reutilizar en el resto de Terreno en vez del Badge.vue genérico (borde
// grueso, texto con sombra, fondo saturado) que desentonaba con el resto
// del módulo, construido sobre las variables --terrain-*/--color-*.
export default {
  name: 'TerrainBadge',
  props: {
    // success | warning | danger | secondary
    type: { type: String, default: 'secondary' },
    message: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.terrain-badge {
  background: var(--color-mist);
  border: 1px solid var(--color-line);
  border-radius: var(--terrain-radius-xl);
  color: var(--color-ghost);
  display: inline-block;
  font-size: var(--terrain-font-caption);
  font-weight: 700;
  line-height: 1.4;
  padding: 2px var(--terrain-space-sm);
  white-space: nowrap;

  &--success { background: var(--terrain-color-success-light); border-color: var(--color-success); color: var(--color-success); }
  &--warning { background: var(--terrain-color-warning-light); border-color: var(--color-warning); color: var(--color-warning); }
  &--danger { background: var(--terrain-color-danger-light); border-color: var(--color-danger); color: var(--color-danger); }
  &--secondary { background: var(--color-mist); border-color: var(--color-line); color: var(--color-ghost); }
}
</style>
